export enum TaskSubject {
    AskInformation = 'ask-information',
    FirstContact = 'first-contact',
    Return = 'return',
    Reminder = 'reminder',
    ThanksAfterInterview = 'thanks-after-interview',
    ThanksForIntroduction = 'thanks-for-introduction',
    ThanksAfterRecruitmentFailed = 'thanks-after-recruitment-failed',
    RequestForInformation = 'request-for-information',
    SendInformation = 'send-information',
    SendOffer = 'send-offer',
    Thanks = 'thanks',
    Feedback = 'feedback',
    WishCard = 'wish-card',
    UpdateJobboardsCvs = 'update-jobboards-cvs',
    SendApplication = 'send-application',
    ReminderApplication = 'reminder-application',
    InterviewPreparation = 'interview-preparation',
    InternetSearches = 'internet-searches',
    Other = 'other',
}

export const TaskSubjectWithoutContact = [
    TaskSubject.UpdateJobboardsCvs,
    TaskSubject.InterviewPreparation,
    TaskSubject.InternetSearches,
    TaskSubject.Other,
];

export const TaskSubjectWithoutApplication = [
    TaskSubject.FirstContact,
    TaskSubject.Return,
    TaskSubject.Reminder,
    TaskSubject.RequestForInformation,
    TaskSubject.AskInformation,
    TaskSubject.SendInformation,
    TaskSubject.SendOffer,
    TaskSubject.Thanks,
    TaskSubject.Feedback,
    TaskSubject.WishCard,
    TaskSubject.UpdateJobboardsCvs,
    TaskSubject.InterviewPreparation,
    TaskSubject.InternetSearches,
    TaskSubject.Other,
];

export const TaskSubjectWithApplication = [
    TaskSubject.FirstContact,
    TaskSubject.SendApplication,
    TaskSubject.ReminderApplication,
    TaskSubject.SendOffer,
    TaskSubject.Return,
    TaskSubject.Feedback,
    TaskSubject.AskInformation,
    TaskSubject.SendInformation,
    TaskSubject.Other,
];
